import { Component, HostListener, Input, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import {RepAuxMoxService, CtbTipo} from './rep-aux-mox.service';
import {ExportFileService} from './export-file.service';
import { LoginService } from '../../login/login.service';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogoCtbPolComponent } from '../ctb-pol/catalogo-ctb-pol/catalogo-ctb-pol.component';
import { NgZone } from '@angular/core';
import { PeriodoEjercicioService } from '../../control/periodo.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-rep-aux-mov',
  templateUrl: './rep-aux-mov.component.html',
  styleUrls: ['./rep-aux-mov.component.css'],
  providers: [ExportFileService, DatePipe],
  preserveWhitespaces: true
})
export class RepAuxMovComponent implements OnInit {
  movimientos = [{id: 1, titulo: 'Con Movimientos'}, {id: 2, titulo: 'Sin Movimientos'}];

  public tipoCuentas: CtbTipo[] = [];
  public lista_cuentas: any[] = [];
  rep: any[] = [];
  public showList: boolean = false;
  @Input()
  public ano: number = 0;
  @Input()
  public mes: number = 0;
  public anos: any[] = [];
  fecha_ini = '';
  fecha_fin = '';
  movimiento: number = 1;
  tipo_cuenta: number = 0;
  cuenta_filtro: String = '';
  limite: number = 5;
  saldo: number = 0;
public empresa_id: string = '';
public empresa: string = '';

  constructor(private route: ActivatedRoute,
    private service: RepAuxMoxService,
    private exportTo: ExportFileService,
    private date: DatePipe, private loginService : LoginService, private modalService: NgbModal,private ngZone: NgZone, private PeriodoEjercicioService: PeriodoEjercicioService
  ) { }
  filterOptions() {
    this.cuenta_filtro.toLowerCase();
    console.log(this.cuenta_filtro.toLowerCase());
    this.service.autocompletadoAuxiliarMovimientos(this.cuenta_filtro,  Number(this.empresa_id),this.fecha_ini, this.fecha_fin).subscribe(
      response => {
        this.lista_cuentas = response.contenido;
        this.showList = true;
      }
    );
  }
 // Detecta clic fuera del elemento y oculta la lista
 @HostListener('document:click', ['$event'])
 onClickOutside(event: Event) {
   const target = event.target as HTMLElement;
   if (!target.closest('.col-sm-2')) {
     this.showList = false; // Oculta la lista si haces clic fuera del input o ul
   }
 }
  selectOption(option: string) {
    this.cuenta_filtro = option;
    this.showList = false;
  }
  ngOnInit(): void {
    this.mes = Number(this.route.snapshot.queryParamMap.get('mes')?.toString() || '0');
    this.ano = Number(this.route.snapshot.queryParamMap.get('ano')?.toString() || '0');
    if(this.mes ==0){
    this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ano = ejercicio ? ejercicio : 0;
      console.log(this.ano);

    });
      this.PeriodoEjercicioService.periodo$.subscribe(periodo => {
      this.mes = periodo ? periodo : 12;
      if(this.mes == 13){
this.mes =12;
      }
    });
  } else {
    this.selectOption(this.route.snapshot.queryParamMap.get('cuenta')?.toString() || '');
  }
  this.empresa_id = this.loginService.empresa + '';
  this.empresa = this.loginService.usuario.empresa_seleccionada.titulo;
    this.cargarTpCuentas();
    this.cargarAnos();
    this.asignarFechas(this.mes);
  }
  asignarFechas(mes: number){
    this.fecha_ini = this.date.transform(new Date(this.ano,mes-1, 1), 'yyyy-MM-dd');
    this.fecha_fin = this.date.transform(new Date(this.ano, mes, 0), 'yyyy-MM-dd');
    this.fecha_ini = this.fecha_ini;
    this.fecha_fin =this.fecha_fin;
    this.reporte();
  }
  cargarAnos() {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
      
  }
  reporte() {
    if (this.fecha_ini > this.fecha_fin) {
      Swal.fire('Error!', 'La fecha de inicio es mayor que la fecha fin!', 'error');
      this.fecha_ini = '', this.fecha_fin = '';
      this.rep = [];
    } else {
      this.mostrarMensajeCarga();
      this.service.getReporteAuxMov(this.fecha_ini, this.fecha_fin, this.movimiento, this.tipo_cuenta, this.cuenta_filtro, this.empresa_id,this.limite).subscribe(
      response => {
        this.rep = response as any[];
        //this.calcSaldo();
        /*const suma = this.rep.reduce((sum, currentValue) =>{
          return sum + currentValue.saldo;
        }, 0);*/
        //console.log(suma);
        this.cerrarMensajeCarga();
      }, err => {
        Swal.fire('Error!', err.error.error, 'error');
      });
    }
  }
  getReporteTPdf(){
    this.mostrarMensajeCarga();
    if (this.fecha_ini > this.fecha_fin) {
      Swal.fire('Error!', 'La fecha de inicio es mayor que la fecha fin!', 'error');
      this.fecha_ini = '', this.fecha_fin = '';
      this.rep = [];
    } else {
      //this.exportTo.exportAsPDF(this.rep, 'Reporte auxiliar de movimientos');
      this.service.getReporteTPdf(this.fecha_ini, this.fecha_fin,  this.tipo_cuenta,  Number(this.empresa_id)).subscribe(
        response => {
          this.cerrarMensajeCarga();
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = this.empresa.toLowerCase() + '_libro_mayor_' + this.fecha_ini + '_' + this.fecha_fin;
          document.body.appendChild(a);
          a.click();
        }, err => {
          this.cerrarMensajeCarga();
          Swal.fire('Error!', 'No existe información para exportar de ' + this.fecha_ini + ' a ' + this.fecha_fin, 'error');
        }
      );
    }
  }

  limpiarBusqueda(): void {
    //this.fecha_ini = '';
    //this.fecha_fin = '';
    this.fechaIn();
    this.fechaFn();
    this.mes = 1;
    this.movimiento = 1;
    this.tipo_cuenta = 0;
    this.cuenta_filtro = '';
    this.reporte();
  }

  exportToExcel(): void {
    if (this.rep == undefined) {
      Swal.fire('Aviso', 'La tabla no contiene datos el cual exportar a un archivo Excel', 'warning');
    } else {
      this.exportTo.exportAsExcelFile(this.rep, this.empresa.toLowerCase() + '_reporte_auxiliar_de_movimientos_' + this.fecha_ini + '_A_' + this.fecha_fin);
    }
  }

  exportToPdf() {
    this.exportAsPdfFile(this.rep, 'reporte_auxiliar_de_movimientos ' + this.fecha_ini + ' A ' + this.fecha_fin);
   /**  if (this.rep == undefined) {
      Swal.fire('Aviso', 'La tabla no contiene datos el cual exportar a un archivo PDF', 'warning');
    } else {
      
    this.mostrarMensajeCarga();
      //this.exportTo.exportAsPDF(this.rep, 'Reporte auxiliar de movimientos');
      this.service.getPdf(this.fecha_ini, this.fecha_fin, this.movimiento, this.tipo_cuenta, this.cuenta_filtro, this.empresa_id, this.empresa,this.limite).subscribe(
        response => {
          this.cerrarMensajeCarga();
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'Reporte_aux_mov_' + this.fecha_ini + '_' + this.fecha_fin;
          document.body.appendChild(a);
          a.click();
        }
      );
    }*/
  }


exportAsPdfFile(json:any, pdfFileName:any) {
  const empresa = this.empresa;
  
  // Preparar los datos para la tabla
  const data = [];
  
  // Añadir fila de título principal
  data.push([
    'TNK CONTABILIDAD',
    '',
    empresa || '',
    '', 
    '',
    '',
    ''
  ]);
  
  // Añadir fila de subtítulo
  data.push([
    '',
    '',
    `REPORTE AUXILIAR DE MOVIMIENTOS ${this.fecha_ini} A ${this.fecha_fin}`,
    '',
    '',
    '',
    ''
  ]);
  
  // Añadir encabezados de columna
  data.push([
    'Póliza',
    'Fecha',
    'Concepto',
    'Saldo Inicial',
    'Cargos',
    'Abonos',
    'Saldo Final'
  ]);
  
  // Añadir datos del JSON
  json.forEach(item => {
    data.push([
      item.folio || '',
      item.fecha || '',
      item.descripcion || '',
      item.saldo_inicial || '0.00',
      item.cargo || '0.00',
      item.abono || '0.00',
      item.saldo_final || '0.00'
    ]);
  });
  
  // Crear documento PDF
  const doc = new jsPDF('landscape'); // Usar landscape para más espacio horizontal
  
  // Configurar estilos para las filas especiales
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('TNK CONTABILIDAD', 14, 15);
  
  doc.setFontSize(14);
  if (empresa) {
    doc.text(empresa, doc.internal.pageSize.width - 14 - doc.getTextWidth(empresa), 15);
  }
  //doc.text('lalalalalalala', doc.internal.pageSize.width - 14 - doc.getTextWidth('lalalalalalala'), 15);
  doc.setFontSize(12);
  doc.text(`REPORTE AUXILIAR DE MOVIMIENTOS ${this.fecha_ini} A ${this.fecha_fin}`, 14, 25);
  
  // Crear la tabla
  autoTable(doc, {
    head: [data[2]], // Usar la tercera fila como encabezado
    body: data.slice(3), // Todas las filas después de la tercera como cuerpo
    startY: 35,
    theme: 'grid',
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: 'bold',
      fontSize: 10,
        halign: 'center'
    },
    bodyStyles: {
      fontSize: 9
    },
    columnStyles: {
      0: { cellWidth: 25 }, // Póliza
      1: { cellWidth: 25 }, // Fecha
      2: { cellWidth: 60 }, // Concepto
      3: { cellWidth: 30 }, // Saldo Inicial
      4: { cellWidth: 25 }, // Cargos
      5: { cellWidth: 25 }, // Abonos
      6: { cellWidth: 30 }  // Saldo Final
    },
    styles: {
      overflow: 'linebreak',
      cellPadding: 2,
      halign: 'left'
    },
    //margin: { left: 14, right: 14 }
  });
  
  // Guardar el PDF
  doc.save(this.empresa.toLowerCase() + '_' + `${pdfFileName}.pdf`);
}

  cargarTpCuentas() {
    this.service.getTipoCuenta().subscribe(response => {
      this.tipoCuentas = response;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }

  fechaIn() {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    let ddStr = '';
    let mmStr = '';

    ddStr = '01';

    if (mm < 10) {
      mmStr = '0' + mm
    } else {
      mmStr = mm + '';
    }
  this.fecha_ini = yyyy + '-' + mmStr + '-' + ddStr;
  }

  fechaFn() {
    const diaFinalMesActual = new Date();
    diaFinalMesActual.setDate(diaFinalMesActual.getDate() - 1);
    diaFinalMesActual.setDate(0);

    diaFinalMesActual.setMonth(diaFinalMesActual.getMonth() + 1);

    this.fecha_fin = this.date.transform(diaFinalMesActual, 'yyyy-MM-dd');
  }
  mostrarMensajeCarga() {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton:false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    Swal.close();
  }
  abrirModalPolizas() {
  this.ngZone.run(() => {
    this.modalService.open(CatalogoCtbPolComponent, { size: 'lg' });
  });
}

abrirFormularioPoliza(item: any) {
  if(item.tipo=='c'){
    this.abrirCuenta(item);
  } else {
this.abrirPoliza(item);
  }
  
}

abrirPoliza(item: any) {
  const params = new URLSearchParams();
  params.set('folio', item.folio); // tu parámetro
  params.set('fecha', item.fecha); // opcional
  params.set('concepto', item.descripcion); // opcional

  const url = `/#/contabilidad/proceso/ctb-pol?${params.toString()}`;

    const width = window.screen.width * 0.8;   // ancho de la ventana (50%)
const height = window.screen.height * 0.8; // alto de la ventana (50%)

// Calculamos la posición centrada
const left = (window.screen.width - width) / 2;
const top = (window.screen.height - height) / 2;

const ventana = window.open(
  url,
  'VisualizarCuenta',
  `top=${top},left=${left},width=${width},height=${height},resizable=yes,scrollbars=yes`
);
}

abrirCuenta(item: any) {
  const params = new URLSearchParams();
  params.set('cuenta', item.folio); // tu parámetro
  params.set('nombre', item.descripcion); // opcional
params.set('sinMenu', 'true');
  const url = `/#/contabilidad/catalogo/ctb-cta?${params.toString()}`;

  const width = window.screen.width * 0.8;   // ancho de la ventana (50%)
const height = window.screen.height * 0.8; // alto de la ventana (50%)

// Calculamos la posición centrada
const left = (window.screen.width - width) / 2;
const top = (window.screen.height - height) / 2;

const ventana = window.open(
  url,
  'VisualizarCuenta',
  `top=${top},left=${left},width=${width},height=${height},resizable=yes,scrollbars=yes`
);
}
}
